// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"style_card-wrapper__IuLVT","button":"style_button__L_tiM","mobile-card-wrapper":"style_mobile-card-wrapper__WTjEq"};